import React, { createContext, useState, useContext, } from 'react';
var GalleryMenuContext = createContext({
    activeGalleryLink: null,
    allLinks: null,
    setActiveGalleryLink: function () { }
});
export var useGalleryMenuContext = function () {
    return useContext(GalleryMenuContext);
};
export var GalleryMenuContextProvider = function (_a) {
    var defaultActiveLink = _a.defaultActiveLink, _b = _a.allLinks, allLinks = _b === void 0 ? null : _b, children = _a.children;
    var _c = useState(defaultActiveLink || null), activeGalleryLink = _c[0], setActiveGalleryLink = _c[1];
    return (React.createElement(GalleryMenuContext.Provider, { value: { activeGalleryLink: activeGalleryLink, allLinks: allLinks, setActiveGalleryLink: setActiveGalleryLink } }, children));
};
